import { redirect } from "@tanstack/react-router"
import { createServerFn } from "@tanstack/react-start"

import { clearSessionCookie } from "../session.server"

export const logout = createServerFn({ method: "POST" }).handler(async () => {
  await clearSessionCookie()
  throw redirect({ to: "/login" })
})
